const en_master_tnc_setting = {
    "": "terms and conditions",

    field: {
        PPN: "PPN",
        PWP: "price includes PPN",
        KSPOOUT: "outgoing PO header",
        RCUST: "customer return (returned to specific warehouse)",
        VA: "virtual account",
        TOCPO: "purchase order terms and conditions",
        TOCPLPO: "packing list purchase order terms and conditions",
        TOCSO: "sales order terms and conditions",
        TOCPLSO: "packing list sales order terms and conditions",
        TOCINV: "invoice terms and conditions",
        TPO: "purchase order template",
        TSO: "sales order template",
        TDO: "delivery order template",
        TINV: "invoice template",
        PRODWH: "production destination warehouse"
    },

    error: {
        edit: "Failed to update terms and conditions.",
    },

    success: {
        edit: "Terms and conditions updated successfully.",
    },
}

export default en_master_tnc_setting;